import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setUserProfile = profile =>
  call(websocketFetch, 'set_user_profile', profile);
